import type { FC } from 'react';

import Template from '../Template';
import { listDesktop, listMobile } from './content';

const Unknown: FC = () => {
    return <Template listDesktop={listDesktop} listMobile={listMobile} />;
};

export default Unknown;
